import { createSvgComponent } from "../../icon/createSvgComponent";
import ArrowDown from "@core/__generated__/icon/figma/arrow-down.svg";
export default createSvgComponent(ArrowDown);